/**
 * 中文国际化文件
 */
const message = {
  //公共按钮
  common: {
    button_confirm: '确认',
    button_ok: '确定',
    button_save: '保存',
    button_cancel: '取消',
    button_search: '查询',
    button_search2:'搜索',
    button_reset: '重置',
    button_add: '新增',
    button_add2:'添加',
    button_del: '删除',
    button_edit: '编辑',
    button_view: '查看',
    button_record: '记录',
    button_push: '推送',
    button_import:'导入',
    button_export: '导出',
    button_batch_import: '批量导入',
    button_back:'返回',
    button_refresh:'刷新',
    button_operate:'操作',
    button_save_and_return:'保存并返回',
    button_open:'开启',
    button_off:'关闭',
    button_more_option:'更多',
    button_clone:'克隆',
    button_next_step:'下一步',
    button_exportReport:'导出报表',
    del_confirm_title:'确认删除',
    del_config_tips1:'您将删除所有已勾选的配置，请确认',
    del_config_tips2:'您将删除所有已勾选的配置，同时设备也会清除这些配置，请确认',
    push_range:'推送范围',
    push_status:'推送状态',
    finish_status:'完成状态',
    config_name:'配置名称',
    param_version:'版本号',
    version:'版本',
    operate_tip:'提示',
    operation_success:'操作成功',
    delete_success: '删除成功',
    export_task_tip:'导出操作可能耗费一点时间，结果将显示在报表 >> 导出任务',
    chunk_load_error_tip: '页面资源加载失败，请手动刷新后重试'
  },
  menu: {
    my_device:'我的设备',
    data_center:'数据中心',
    remote_clear_lockpass : '清除锁屏密码',
    device_restore : '设备还原',
    address_manage : '位置管理',
    restore_date_record:'恢复出厂记录',
    remote_usage_record : '使用记录',
    remote_manage_menu : '远程管理',
    remote_app_manage: '应用管理',
    remote_configuration:'远程设置',
    devicedistributionmanage : '设备归属管理',
    sysCustomization:'系统定制',
    devicedistribution : '设备分发',
    devicedonate : '设备赠送',
    devicedonaterecord : '赠送&接收记录',
    occupyScreen:'霸屏模式',
    silentApp:'默启应用',
    customDesk:'自定义桌面',
    bootAnimation:'开机动画',
    index : '位置',
    dashboard : '主页',
    usermanage : '用户管理',
    userinfo : '用户信息',
    userlist : '用户列表',
    useredit : '用户编辑',
    useradd : '用户添加',
    changepass : '修改密码',
    organization : '机构管理',
    organizationlist : '机构列表',
    organizationadd : '机构添加',
    organizationdetail : '机构详情',
    app : '应用管理',
    applist : '应用列表',
    authorityManagement : '权限管理',
    otaParamManagement : 'OTA参数管理',
    apppublish : '应用发布',
    appshelf : '应用上架',
    onshelf:'已上架应用',
    notonshelf:'未上架应用',
    appadd : '添加应用',
    appupdate : '应用更新',
    device : '设备管理',
    device_management : '管理',
    devicemonitor : '设备信息监控',
    fence : '电子围栏',
    drawfence : '围栏圈定',
    deviceexport : '设备批量导入',
    deviceadd : '设备添加',
    deviceedit : '设备编辑',
    functionforbidden : '功能禁用',
    configuration : '配置管理',
    appcenter : '应用中心配置',
    thirdapp : '第三方应用配置',
    notfound : '找不到页面',
    errorpage : '错误页面',
    home : '主页',
    dataCenter:'数据中心',
    deviceMap:'设备地图',
    account_manage :'商户信息管理',
    company_info : '公司信息',
    personal_info : '个人信息',
    my_operator : '我的操作员',
    children_account :'子商户',
    my_children_account :'我的子商户',
    app_market:'应用市场',
    menu_banner:'广告栏',
    menu_app_upload : '应用上传',
    menu_inside_app:'内部应用',
    menu_app_check : '应用审核',
    app_manage : '应用管理',
    app_detail : '应用详情',
    app_add : '应用详情',
    app_param_config:'参数配置',
    app_deploy:'应用部署',
    app_version_manage : '版本管理',
    app_manage_content : '管理内容',
    device_app_info:'设备应用信息',
    device_life_cycle:"设备生命周期",
    remote_assistance:'远程协助',
    device_config:'设备配置',
    my_boot_animation:'我的开机动画',
    group_manager:'分组管理',
    remote_screen:'远程桌面',
    after_sale_service:'售后服务',
    apply_after_sale:'申请售后',
    service_progress:'售后进度',
    flowManagement:'流量管理',
    flow_manage:'流量管家',
    flowLimitWarn:'限额提醒',
    visitInfoStatistic:'到访信息统计',
    abnormalAlarmStatistics:'异常告警统计',
    organization_management: '机构管理',
    manufacturer_management: '型号管理',
    manufacturer_dvc_type:'设备型号',
    device_detail:'设备详情',
    device_detail_tab:'设备详情',
    device_tabs:'设备信息',
    param_add:'新增应用参数',
    param_edit:'应用参数克隆',
    param_edit1:'应用参数编辑',
    param_view:'查看应用参数',
    organization_management_another: '机构管理',
    organization_management_repository: '机构设备仓库',
    opt: 'OTP',
    mas_list:"MAS 列表",
    policyManagement: '策略管理',
    configurationManagement: '配置管理',
    basesetting: '基础设置',
    operation_log: '操作日志',
    authority_management: '权限管理',
    platform_settings:'平台设置',
    ota: 'OTA',
    device_task:'设备任务',
    occupy_screen:'霸屏应用',
    report: '报表',
    device_conn_analysis:'设备连接分析',
    network_conn_analysis:'网络连接分析',
    device_location_change:'设备位置变化',
    alive_device_analysis:"设备活跃情况",
    paramManage: '参数管理',
    paramManage_dict: '参数字典',
    paramManage_manage: '参数管理',
    log_manage:"日志管理",
    deviceEMVLog:"日志",
    bulk_task:"批量任务",
    export_task:"导出任务",
    deviceApp_installStatistics:'应用安装情况',
  },
  //登录模块
  login:  {
    username:'用户名',
    usernametip : "账号/邮箱",
    password : "密码",
    verifycode : '验证码',
    rememberMe:'记住用户名',
    loginbtn : '登录',
    register_btn:'注册',
    platformName:'合作伙伴平台',
    login_check_company_input:'请点击商户信息管理-公司信息页面填写公司信息',
    repeat_login:'当前账号已登录，是否强制登录',
    login_password_overdue:'密码已经过期，请重新设置新的密码！',
    login_password_expiring:'密码有效期不足七天请尽快更新密码！',
    simplePassword:'你设置的密码太简单了，为了企业信息安全，请重新设置',
    numberLetterRepeatFiveTimes:'不可包含5个及以上重复数字或字母',
    fiveContinuousNumber:'不可包含5个及以上连续数字',
    atLeastSixContainLetterNumber:'密码最少6位,必须含字母及数字',
    updatebrowser : '请更新浏览器',
    password_rule: '密码至少包含一个大写字母，一个数字，一个特殊字符，并且长度在8-20之间',
    password_inconsistency : '两次输入密码不一致',
    password_old : '请输入原来的密码',
    password_new_more : '请再次输入新密码',
    username_rule : '账号不符合规则',
    password_rule_1 : '密码长度6-16位,必须含字母及数字',
    verifycode_empty:'请输入验证码',
    email_rule : '请输入正确的邮箱地址',
    avatar_rule : '头像大小不得超过500KB',
    avatarupload : '头像上传',
    oldpassword : '当前密码',
    confirmnewpassword : '重复新密码',
    batchlogout_confim_tip : '确认退出登录，是否继续？',
    batchh_return_parent_account_tip:'确认返回母商户，是否继续？',
    avatar_format_rule : '只能上传jpg,jpeg格式的文件',
    warning: {
      name: '告警信息',
      fence_item: '超出了设备围栏',
      ip_item: '登录IP地址异常',
      no_data: '暂无数据',
      login_record_title: '登录IP异常告警',
      login_record_time: '登录时间',
      login_record_current: '本次登录',
      login_record_last: '上次登录',
      password_err_warning: '尝试登录，密码错误',
    },
    register:{
      partner:'合作平台伙伴',
      verify_identidy:'验证身份',
      account:'商户',
      active_success:'激活成功',
      active_fail:'激活链接已失效',
      lock_tip1: '登录失败次数过多，账号已被锁定。',
      lock_tip2: '点击下方按钮发送解锁邮件到已提供的邮箱',
      btn_send: '发送解锁邮件',
      tip_sending: '邮件发送中...',
      tip_send_success: '邮件发送成功',
      email_tip:'请输入邮箱地址',
      password_tip:'请输入密码',
      password_again:'确认密码',
      password_again_tip:'请确认密码',
      verify_code: '请输入验证码',
      register_now:'立即注册',
      register_email_send_tip1:'激活邮件已发送至您的注册邮箱',
      register_email_send_tip2:'请在24小时内',
      register_email_send_tip3:'点击邮件内链接完成注册',
      register_email_check:'立即查收邮件',
      agree_service_items:'同意服务条款',
      no_email_received:'未收到邮件',
      register_email_again_send:'重新发送邮件',
    },
    firstLogin: {
      title: '请重新设置密码',
      relogin: '重新登录',
      relogin_tip: '重新设置密码后，需要重新登录系统。',
      },
    function : {
      logout : '退出登录',
      changePic:'更换头像',
      changePwd:'修改密码',
      return_manage:'返回母商户',
    },
    reset:{
      register_password:'重置密码',
      email_reset_password:'邮箱重置',
      tel_reset_password:'手机号重置',
      email_check_reset_password:'邮箱验证',
      button_content_step1:'发送验证码',
      again_send_code:'重新发送验证码',
      resend_code_again_after:'后重新发送',
      email_reset:'重置邮箱',
    },
  },
  //首页
  dashboard:{
    users : '用户数',
    devices : '设备数',
    device_total_num:"设备总数",
    alive_device:"在线设备",
    joined_in_seven_days:"七天内新加入",
    device_abnormal_status:"设备异常状态",
    device_need_charge:"需要充电的设备20%以下",
    device_disable:"禁用设备",
    device_offline:"离线设备",
    device_offline_over_forty_eight_hours:"离线超过48小时",
    device_report_over_forty_eight_hours:"信息上报超过48小时",
    device_map:"设备地图",
    warn_log:"警告日志",
    warn:"警告",
    sn:"SN",
    org:"机构",
    record_time:"记录时间",
    device_fence_warn_tip:"设备离开设备围栏",
    alive_device_month:"月活跃度",
    alive_device_week:"周活跃度",
    alive_device_num:"活跃设备数",
    un_bind_device_num:"未绑定设备总数",
    bind_device_num:"已绑定设备总数",
    un_bind_device_count:"未绑定设备数",
    bind_device_count:"绑定设备数",
    statistic: {
      device_status : '设备状态占比',
      device_operator : '运营商分布',
      operator_detail : '详情信息',
      device_status_detail : '设备详情',
      system_version_distribution: 'Android系统版本',
      OSVersion_distribution: 'OS版本信息',
      apps_installation : '应用安装详情',
      apps_installed : '已安装',
      apps_name : '应用名称',
      apps_device : '设备数'
    },
  },
  //应用相关
  app_market:{
    check :{
      auto_mode:'自动审核',
      manual_mode:'人工审核',
      wait_check:'待审核',
      pass_check:'通过',
      refuse_check:'不通过',
      add_balcklist_tip:'是否添加到审核黑名单？',
      check_mode:'审核模式',
      view_black_list:'查看黑名单',
      check_progress:'审核进度',
      putin_app_name:'请输入应用名称',
      app_name:'应用名称',
      app_version_code:'应用版本',
      app_version_name:'版本名称',
      submit_user:'提交用户',
      submit_time:'提交时间',
      progress:'进度',
      no_pass_check:'不通过',
      app_package:'应用包名',
      remove_app_blacklist:'移出黑名单',
      no_pass_tip:'审核结果: 应用审核不通过！',
      fail_reason:'失败原因:',
      no_check:'未审核',
      ing_check:'审核中',
      check_pass:'审核通过',
      click_icon_tip:'点击图标可编辑应用信息',
      check_no_pass:'审核不通过',
      app_download:'下载',
      apply_push:'申请发布',
      cancel_apply:'取消申请',
      wait_check_tip:'审核需要3-5个工作日，请耐心等待！',
      push_apply_confirmation:'发布申请确认',
      apply_confirmation_tip:'发布申请后，审核需要3-5个工作日，请耐心等待。',
      cancel_check_apply:'撤回审核申请',
      cancel_apply_tip:'应用正等待管理员审核，是否撤回申请？',
      re_apply_check:'重新申请',
      re_apply_confirmation:'是否对此应用再次申请审核？',
      has_shelf_app:'已上架应用',
      app_unshelf:'应用下架',
      no_shelf_app:'未上架应用',
      app_shelf:'应用上架',
      app_detail:'详情',
      app_shelf_org:'分组上架',
      app_org_select:'分组选择',
      add_inside_app:'新增应用',
      file_size:'应用大小',
      update:'更新',
      app_version_note:'版本说明',
      version_update:'版本更新',
      select_busstype:'请选择行业类型',
      putin_app_check_note:'请输入审核意见',
      to_blacklist:'加入黑名单',
      download:'下载',
      copy_tip:'确认要克隆此应用配置吗？',
      app_in_blacklist:'应用已加入黑名单',
      app_out_blacklist:'应用已移出黑名单，请重新申请审核',
      type_chage:'开启自动审核后所有应用申请都会自动通过，请谨慎选择！',
      to_auto:'是否开启自动审核？',
      to_handle:'是否开启人工审核？',
      select_apk:'请点击此处上传apk格式文件',
    },
    //应用部署相关
    appDeploy:{
      del:{
        tip1:'确认删除',
        tip2:'您将删除所有选定的配置，请确认',
      },
      table:{
        nopush:'未推送',
        yespush:'已推送',
        allpush:'全局推送',
        partpush:'部分推送',
        inputorgname:'请输入机构名称查询',
      },
      record:{
        view:'查看推送内容',
        pushRange:'查看推送范围',
        name:'名称',
        user:'操作员',
        pushrange:'推送范围',
        time:'操作时间',
        operateRecord:'操作记录',
      },
      app_addTip:'选择需要部署的应用',
      app_deploy_manage:'应用部署',
      app_white_list:'应用白名单',
      app_survival_list:'应用保活名单',
      to_deploy_app:'部署应用',
      tree_empty:'暂无数据',
      deploy_push_manage:'推送管理',
      config_name:'配置名称',
      version:'版本:',
      deploy_schedule:'执行进度',
      deploy_time_not_empty:'请选择部署时间',
      deploy_must_input:'必填',
      deploy_must_select:'必选',
      deploy_install_mode0:'静默安装',
      deploy_install_mode1:'下载后通知用户安装',
      deploy_select_app:'应用选择',
      deploy_current:'立即部署',
      deploy_select:'选择部署时间',
      deploy_select_time:'选择时间',
      deploy_app_mode:'部署方式',
      deploy_app_interval:'部署时间',
      app_deploy_manage_detail:'查看应用部署',
      config_name_not_empty:'规则名称不能为空',
      deploy_type_not_empty:'请选择部署方式',
    },
    appSurvivalList:{
      name:'名称',
      pushRange:'推送范围',
      content:'应用选择',
      app_name:'名称',
      app_package:'包名',
      add_app:"添加应用",
      app_name_is_empty:"应用名称不能为空",
      app_package_is_empty:"应用包名不能为空",
      app_content_is_have_one:"保留一条数据",
      app_survivalList_name_is_empty:"应用保活名单配置名称不能为空",
      app_survivalList_push_group_is_empty:'推送分组不能为空',
      app_survivalList_content_is_empty:"应用保活名单内容不能为空",
      app_survivalList_check_app_name_is_empty:"应用选择的名称不能为空",
      app_survivalList_check_app_package_is_empty:"应用选择的包名不能为空",
      survivalList_app:'保活名单应用',
      app_survivalList_name_duplication:'应用保活名单配置名称已存在'
    },
    appWhitelist:{
      name:'名称',
      pushRange:'推送范围',
      content:'应用选择',
      app_name:'名称',
      app_package:'包名',
      add_app:"添加应用",
      app_name_is_empty:"应用名称不能为空",
      app_package_is_empty:"应用包名不能为空",
      app_content_is_have_one:"保留一条数据",
      app_whitelist_name_is_empty:"应用白名单配置名称不能为空",
      app_whitelist_push_group_is_empty:'推送分组不能为空',
      app_whitelist_content_is_empty:"应用白名单内容不能为空",
      app_whitelist_check_app_name_is_empty:"应用选择的名称不能为空",
      app_whitelist_check_app_package_is_empty:"应用选择的包名不能为空",
      app_whitelist_tip:"提示",
      app_whitelist_tip1:"1、应用白名单开启后，会卸载非白名单应用！请慎重操作！",
      app_whitelist_tip2:"2、若手动安装新应用，请更新应用白名单，否则应用会安装失败。",
      whitelist_app:'白名单应用',
      whitelist_tip:'该分组应用部署、自定义桌面推送过的应用',

    },
    appManage:{
      no_select:'请至少选择一个应用',
      no_select_org:'请勾选需要上架的机构！',
      param_version:'版本号',
      device_group_allDevice:'全部设备',
      app_name:'名称',
      enter_config_name:'请输入规则名称',
      add_path:'路径',
      enter_config_path:'格式如:/sdcard/MDM',
      add_param:'新增参数',
      edit_param:'编辑参数',
      type_of_text:'文本',
      type_of_switch:'开关',
      param_name:'参数名称',
      param_type:'参数类型',
      param_value:'参数内容',
      param_remark:'备注',
      enter_param_name_tip:'请输入参数名称',
      enter_param_value_tip:'请输入参数内容',
      enter_param_remark_tip:'请输入参数备注',
      import_param_title:'导入参数',
      upload_param_config_tip:'请选择要上传的文件',
      download_template:'下载模板',
      no:'序号',
      download_error_import_excel:'下载错误数据',
      param_pic:'壁纸',
      param_desk_method:'桌面类型',
      param_name_empty:'参数名不能为空',
      param_path_empty:'路径不能为空',
      param_name_duplicate:'参数名称重复',
      config_name_empty:'名称不能为空',
      import_tmp_error:'导入失败，请导入正确的模板格式',
      param_list_empty:'参数列表不能为空',
      app_param_error_fileName:'错误参数配置',
      appurl : '应用下载地址',
      appIcon : '应用Icon',
      appIconCheckout:'(大小：不大于100KB,图片格式：PNG/JPG)',
      appIconCheckout_size:'大小：不大于100KB',
      appIconCheckout_pix:'尺寸：140*140像素',
      appIconCheckout_format:'格式：PNG/JPG/JPEG',
      appDesc:"应用简介",
      bussType:"行业分类",
      apppackage : '包名',
      appversion:'版本',
      shelfrevise:'上架调整',
      ShelfDvcType:'上架机型',
      versionState:'版本说明',
      appDescPic:'产品截图',
      appVersionCode : '版本号',
      appDownloadNum:'下载量',
      appproducer: '厂商',
      appdescmaxlength : '请输入不超过1000个字符!',
      appproducerLength : '请输入不超过100个字符!',
      device_type:"设备类型",
      app_delete_all:'您将删除此应用，是否确定删除？',
      app_remarket : '备注:',
      app_desc_pic_upload:'上传描述图片:',
      app_desc_pic_checkout:'(上传格式PNG/JPG，大小不超过5M)',
      uploadapk_tip : '点击上传安装包',
      uploadapk_tip2 : '拖拽安装包到此处上传',
      uploadapk_upload1 : '准备上传: ',
      uploadapk_upload2 : '上传中: ',
      uploadapk_has_upload : '已上传文件: ',
      app_delete_tip:'确认删除该app版本，是否继续？',
      app:'应用',
      app_delete_tip0:'请注意：应用',
      app_del_tip:'会被删除，请慎重操作,已安装在设备上的应用不会被删除',
      shelfList_searchTip:'搜索应用名称/机构名称',
      shelfList_searchTip1:'搜索应用名称',
      param_clone:'参数克隆',
      clone_tip:'您将要克隆此参数配置,是否继续?',
      param_name_length_exceed:'参数名称长度不能超过50个字符',
      no_valid_params:'参数名称或参数类型不能为空',
      device_warn_log:"设备警告日志"
    },
    error : {
      apk_size_rule : 'apk文件不得大于1GB',
      appname_rule : '长度在 1 到 30 个字符',
      bussType_rule :"行业分类不能为空",
      apk_format_rule : '只能上传apk格式的文件',
    },
    alert:{
      appRepet1:'对不起！你上传的APK',
      appRepet2:'已存在。',
      appRepet3:'如此应用确实为贵公司所有，请发邮件到',
      appRepetMail:"uhome{'@'}urovo.com",
      appRepet3_1:'认领应用。认领成功后，该应用会转入您的名下，并保留完整数据。',
      appRepet4:'同名应用：',
      appRepet5:'认领邮件格式：',
      appRepet6:'标题：认领应用',
      appRepet7:'邮件正文：认领应用-同名应用(包名)，联系人，联系方式。并附件中添加公司营业执照，对应软件著作权证明等。',
    },
    tip:{
      operation_fail_upload : '上传文件失败',
      appDescPicSize : '图片大小不得超过5MB!',
      appDescFormatter : '请上传正确格式的图片',
      appDescUploadError : '图片上传出错!',
      appAvatarSize : '图片大小不得超过100KB!',
      appAvatarNotNull : "应用图标不存在",
      appDescNotNull : "请上传应用描述图片",
      appDevTypeNotNull : "请勾选设备类型!",
      no_match:'无匹配数据',
      operation_fail : '操作失败',
      newpassword : '设置新密码',
      newpasswordtip : '新密码--更新之后需要重新登录！',
      selectmoreone : '请至少选择一项',
    },
  },
  //机构管理
  org_manage: {
    org: {
      orgTree: {
        title_create: '创建子机构(商户)',
        placeholder_filter: '请输入机构或商户名',
        check_box_inter: '父子联动',
        check_box_inter1: '全选',
        form_superiorOrgName: '上级机构：',
        form_orgType: '机构类型：',
        form_orgType_SubOrganization: '子机构',
        form_orgType_Merchant: '商户',
        form_orgName: '机构(商户)名称：',
        form_orgName_placeholder: '请输入机构(商户)',
        form_merchant_placeholder: '请输入Merchant ID',
        form_admin_email: '管理员邮箱：',
        form_admin_email_help: "此账号可以登录商户终端管理平台，默认密码为：",
        form_admin_email_placeholder: '请输入管理邮箱',
        form_contactsName: '联系人：',
        form_contactsName_placeholder: '请输入联系人名称',
        form_contacts_phone: '联系电话：',
        form_contacts_phone_placeholder: '请输入联系电话',
        form_address: '商户地址：',
        form_address_placeholder: '请输入商户地址',
        form_remarks: '备注：',
        form_remarks_placeholder: '请输入备注',
        form_btn_create: '创建',
        validate_msg_orgName: '请输入子机构（商户）名称',
        validate_msg_orgName_too_long: '子机构（商户）名长度不能超过125位',
        validate_msg_email: '管理员邮箱不符合规范，请重新输入',
        validate_msg_email_required: '请输入邮箱地址',
        validate_msg_merId: 'Merchant ID 长度不能超过32位',
        validate_msg_contactsName: '联系人名称不能超过100位',
        validate_msg_contactsPhone: '请输入正确的电话格式',
        validate_msg_address: '商户地址长度不能超过100个字符',
        validate_msg_remarks: '备注长度不能超过100个字符',
        add_org_success: '新增机构（商户）成功',
        detail_form_title: '机构详情',
        detail_form_bind_device: '已绑定设备',
        detail_form_storage_device: '终端仓库设备',
        detail_form_orgName: '机构名称：',
        detail_form_orgName_placeholder: '请输入机构名称',
        detail_form_merchantName: '商户名称：',
        detail_form_merchantName_placeholder: '请输入商户名称',
        detail_form_btn_delete_org: '删除机构',
        detail_form_btn_delete_merchant: '删除商户',
        detail_form_btn_create_child: '新建下级组织',
        detail_delete_error_title: '删除机构失败',
        detail_delete_error_title_2: '删除商户失败',
        detail_delete_warning: '提示',
        detail_delete_msg_one: '删除机构(商户)：',
        detail_delete_msg_two: '，该机构(商户)内设备所有配置清空，自动解除绑定，移动到上一级设备仓库，确认删除？',
        detail_delete_success:'删除操作成功',
        detail_update_success:'修改操作成功',
        excel_title_upload: '批量导入机构（商户）',
        excel_download_excel: '下载Excel模板',
        excel_tips_upload: '拖动文件或者点击此处上传',
        excel_title_error: '批量导入失败',
        excel_table_rowAndCol: '行列号',
        excel_table_reason: '错误原因',
        excel_table_title_1: '批量解绑设备',
        excel_table_column_sn: 'SN',
        excel_table_column_time: '绑定时间',
        excel_table_column_orgName: '机构名称',
        btn_batch_unbind: '全部解绑',
        excel_download_template: '下载模板',
        modal_batch_unbind_title: '警告',
        modal_batch_unbind_msg: '设备解除绑定后，将删除所有设备数据，请谨慎操作。',
      },
      expendRow: {
        dvcType: '机型:',
        orgAndMerchant: '商户/机构:',
        status: '状态:',
        status_normal: '正常',
        status_forbidden: '禁用',
        push_org: '分组推送',
        push_sn: 'TID/SN推送',
        config_valid: '生效',
        config_invalid: '不生效',
        placeholder: '请输入搜索关键字',
      }
    },
    search: {
      device_type: '机型：',
      device_sn: 'SN：',
      device_sn_placeholder: '请输入SN号进行查询',
      device_type_placeholder: '请选择机型',
      add_time: '入库时间：',
      add_time_bind: '绑定时间：',
      add_time_placeholder: '请选择日期',
      btn_search: '查询',
    },
    add: {
      btn_add_one: '单件入库',
      modal_add_one: '单件入库',
      form_org_name: '所属机构：',
      form_device_type: '设备类型：',
      form_device_type_placeholder: '请选择设备类型',
      form_device_sn: 'SN：',
      form_device_sn_placeholder: '请输入SN号',
      form_device_tid: 'TID：',
      form_device_tid_placeholder: '请输入TID',
      form_device_remark: '备注：',
      form_device_remark_placeholder: '请输入备注',
      form_btn_add: '入库',
      form_btn_cancel: '取消',

      validate_sn: '请输入设备SN号',
      validate_sn_too_long: '设备SN号长度不超过50位',
      validate_tid_too_long: 'tid长度不超过50位',
      validate_remark_too_long: '备注长度不超过300位',
      validate_manufacture: '请选择设备厂商',
      validate_device_type: '请选择设备型号',

      add_success: '单件入库成功',
    },
    table: {
      storage_time: '入库时间',
      bind_time: '绑定时间',
      device_type: '设备类型',
      operator: '操作人',
      remark: '备注信息',
    },
    bash: {
      btn_bash_storage: '批量入库',
      modal_title_bash_storage: '批量入库',
      modal_btn_download: '下载模板',
      modal_btn_cancel: '取消',
      excel_title_error: '批量导入失败',
      excel_msg_success: '操作成功',
    },
    storageMove: {
      btn: '库存移动',
      btn1: '批量移库',
      modal_title: '移动库存到',
      modal_btn_move: '移动',
      modal_btn_cancel: '取消',
      modal_success: '库存移动操作成功',
    },
    deviceBind: {
      btn: '设备绑定',
      btn1: '批量绑定',
      modal_title: '绑定设备到',
      modal_btn_bind: '绑定',
      modal_btn_cancel: '取消',
      modal_btn_next: '下一步',
      modal_btn_pre: '上一步',
      modal_step_1: '完善设备信息(可选)',
      modal_step_2: '选择绑定主体',
      modal_success: '设备绑定成功',
    },
    deviceUnbind: {
      btn: '设备解绑',
      tip: '提示',
      tip_msg: '解绑设备，会导致设备所有配置清空，移动到设备仓库，确认解除绑定？',
      btn_cancel: '取消',
      success_msg: '解绑操作成功',
    },
    deviceDelete: {
      btn: '设备删除',
      btn1: '批量删除',
      tip: '提示',
      tip_msg: '删除设备，则设备将从系统中移除，确认删除设备？',
      device_delete_temp_again:'温馨提示：是否删除该设备？',
      success_msg: '删除操作成功',
      fail_msg: '删除操作失败',
    },
    // 批量解绑设备
    batchUnbind: {
      btn_name: '批量解绑',
      header_tip: '批量解绑设备',
    },
    uruploader: {
      tip1: '支持文件类型：',
      tip3: '请不要修改模板文件标题行',
      tip4: '文件内容不能超过',
      tip4_1: '60001行',
      ignore_err: '忽略错误数据',
      ignore_err_selected: '勾选：',
      ignore_err_selected_tip: '程序将忽略模板中的错误数据，仅处理能处理的数据；',
      ignore_err_unselected: '不勾选：',
      ignore_err_unselected_tip: '程序仅仅在所有模板数据都正确时，处理数据；',
      download: '下载模板文件',
      batch_success: '文件上传成功，可在报表>批量任务查看导入进度',
      format_err: '仅支持 "xls"、"xlsx" 格式的文件',
      size_err: '仅支持不超过 10M 的文件',
    },
  },

  //设备管理
  device_manage: {
    sn:'SN',
    dvc_type:'设备型号',
    tid:'TID',
    deviceStatus:'设备状态',
    status:'状态',
    devType:'机型',
    property_agency:'产权机构',
    lastOnlineTime:'最后在线时间',
    queryLastOnlineTime:'最后在线时间',
    selectLastOnlineTime:'请选择日期',
    device_task:'设备任务',
    device_task_log_0:'终端任务日志',
    operation:'操作',
    scan:'查看',
    scan_details:'查看详情',
    update_key:'更新秘钥',
    update_title:'更新秘钥',
    update_tip:'您确定更新秘钥吗?',
    update_key_success:'密钥更新成功',
    to_order:'指令性操作',
    to_more:'更多',
    manufacturer_name:'厂商',
    query_dvc_type:'机型',
    mid:'MID',
    utms_sn:'SN',
    sysVersion: 'OS版本',
    seVersion: 'SE版本',
    ufsVersion: 'UFS版本',
    query_condition:'筛选条件',
    device_list_count:'设备列表  共',
    tai:'台',
    last_address:'地理位置',
    export_btn:'导出',
    export_file_name:'设备列表',
    query:'查询',
    reset:'重置',
    device_tab_device_detail:'设备详情',
    device_tab_latest_upload_time:'最后上报时间：',
    device_tab_power:'电量',
    device_tab_power_consumption:'耗电情况',
    device_tab_device_apps:'设备应用',
    detection_time:'检测日期',
    detection_result:'检测结果',
    detection_exception:'异常项',
    exception_item:'异常',
    skip_item:'跳过',
    icc_exception:'ICC',
    mag_exception:'MAG',
    picc_exception:'PICC',
    printer_exception:'打印机',
    scanner_exception:'扫描头',
    frontCamera_exception:'前置摄像头',
    rearCamera_exception:'后置摄像头',
    detection_ok:'健康',
    detection_no:'异常',
    detection_normal:'正常',
    hardware_detection:'硬件检测',
    test_results:'检测结果',
    test_results_1:'共检测 ',
    test_results_item:' 项',
    test_results_2:'通过 ',
    test_results_3:'跳过 ',
    test_results_4:'异常 ',
    device_no:'SN号',
    device_type:'机型',
    option:'操作',
    download_log_file:'下载设备日志',
    ram_dosage:'RAM用量',
    rom_dosage:'ROM总量',
    data_flow:'数据流量',
    data_wifi_flow:'WIFI流量',
    data_sim1_flow:'SIM1流量',
    used:'已用',
    remain:'剩余',
    app_name:'应用名',
    app_version_code:'版本号',
    app_package:'包名',
    app_size:'大小',
    system_app:'系统应用',
    third_app:'第三方应用',
    //指令相关
    order_device_operate:'设备操作',
    order_operate_los:'操作日志',
    operate_content:'操作内容',
    operate_time:'操作时间',
    operator:'操作人',
    browser:'浏览器',
    disable:'禁用',
    enable:'解禁',
    disableBtn:'禁用',
    enableBtn:'启用',
    shutdown:'关机',
    restart:'重启',
    ring:'设备响铃',
    ring_pwd:'密码',
    ring_modal_total:'温馨提示',
    ring_modal_total1:'设备将以最大铃声响铃，可通过输入密码退出。',
    ring_modal_total2:'退出响铃密码',
    ring_modal_total3:'请输入4位数字',
    ring_modal_total_true:'是',
    ring_modal_total_false:'否',
    device_reset:'恢复出厂设置',
    get_device_logs:'提取设备日志',
    remote_desk:'远程桌面',
    clear_oprate : '清除锁屏密码',
    clp_tip : '清除密码后不会导致应用数据丢失，但密码将无法恢复，是否继续？',
    confirm:'确定',
    cancel:'取消',
    device_status:'设备状态',
    on_line:'在线',
    off_line:'离线',
    failReason:'失败原因',
    msg_status_publish_time: '推送时间',
    msg_status_publish_status: '消息状态',
    msg_status_publish: '发送中',
    msg_status_delivered: '在途',
    msg_status_acked: '到达',
    msg_status_dropped: '丢弃',
    msg_status_publish_col: '最近消息状态',
    disable_tip:' 此操作将会禁用设备, 是否继续?',
    enable_tip:' 此操作将会解禁设备, 是否继续?',
    shutdown_tip:'此操作将会使设备关机，是否继续?',
    restart_tip:'此操作将会使设备重启，是否继续?',
    ring_tip:'此操作将会使设备响铃，是否继续?',
    reset_tip:'此操作将会使设备恢复出厂设置，是否继续?',
    get_log_tip:'此操作将会提取设备日志，是否继续?',
    remote_desk_tip:'此操作将会启动设备远程桌面，是否继续?',
    remote_desk_request_expired:'远程桌面请求已过期，请重新发送',
    remote_desk_fail_reason:'远程桌面故障，原因是',
    task_type:'类型',
    task_name:'内容',
    task_status:'执行状态',
    release_time:'下发时间',
    execution_time:'执行时间',
    app_deploy:'应用部署',
    wifi_config:'WIFI配置',
    apn_config:'APN配置',
    function_config:'功能设置',
    param_config:'参数配置',
    message_send:'消息推送',
    fence_config:'地理围栏',
    custom_desktop:'自定义桌面',
    get_device_log:'提取设备日志',
    occupy_screen_log:'霸屏应用',
    boot_animation:'开机动画',
    app_whitelist:'应用白名单',
    wifi_whitelist:'WIFI白名单',
    auto_start_app:'默启应用',
    app_uninstall:'应用卸载',
    policy_management:'策略管理',
    app_black_list:'应用黑名单',
    lock_screen_password:'锁屏密码',
    Advertisement: '广告推送',
    task_executing:'执行中',
    task_executing_fail:'执行失败',
    task_executing_success:'执行成功',
    org_name:'商户',
    device_task_log:'终端任务日志',
    //电量相关
    power_mobile_network:'移动网络待机',
    power_screen:'屏幕',
    power_blueTooth:'蓝牙',
    power_system:'系统',
    phone_standby_power:'手机待机',
    power_wifi:'WIFI',
    current_power:'当前电量:',
    power_consumption_ratio:'耗电比例',
    power_consumption:'耗电',
    acquisition_time:'采集时间',
    power_recharge:'充电',
    power_discharge:'放电',
    device_power:'电量',
    device_power_update_time:'更新时间',
    device_position_info:'位置信息',
    device_location:'设备位置',
    device_historical_track:'历史轨迹',
    historical_track_start_date:'开始日期',
    historical_track_end_date:'结束日期',
    historical_track_map_mode:'地图模式',
    historical_track_data_mode:'数据模式',
    data_mode_table_column_time:'时间',
    data_mode_table_column_longitude:'经度',
    data_mode_table_column_latitude:'纬度',
    data_mode_table_column_position:'地理位置',
    historical_track_select_date_tip:'请选择时间范围',
    historical_track_time:'时间',
    current_location:'当前位置',
    last_location:'上次位置',
    code:'错误码',
    fileName:'日志文件',
    terminalTime:'终端时间',
    uploadTime:'上传时间',
    inputErrorCode:'请输入错误码',
    inputSN:'请输入设备编号SN',
    inputTerminalTime:'请选择终端时间',
    inputUploadTime:'请选择上传时间',
    btn_search:'查询',
    businessType:'业务类型',
    msg:'信息',
    emvLog:'EMV日志',
    triggerEvent:'触发事件',
    file_distributions:'文件分发',
    //wifi配置
    wifiConfig: {
      push_succcess: '推送成功',
      clone_tip_wifi: '提示',
      tab_name: 'WIFI配置',
      addOne: {
        btn: '添加',
        btn1: '编辑',
        modal_title: '添加WIFI配置',
        modal_title1: '编辑WIFI配置',
        form_name: '配置名称',
        form_name_placeholder: '请输入配置名称',
        form_ssid: '服务集标识符（SSID）',
        form_ssid_tip:'要连接的WiFi名称',
        form_network_hide:'隐藏网络',
        form_network_hide_tip:'目标网络非开放网络或未广播信号时，请开启此功能',
        form_safeType:'安全类型',
        form_safeType_tip:'连接时使用的无线网络加密类型',
        form_password:'密码',
        form_password_tip:'无线网络密码',
        qr_code_generate_tip:'请填写设置信息后再生成二维码',
        qr_code_generate:'生成二维码',
        form_btn_cancel:'取消',
        form_btn_confirm: '添加',
        form_btn_confirm1: '编辑',
        validate_name: '请输入配置名称',
        validate_name_too_long: '配置名称过长',
        validate_ssid: '请输入ssid',
        validate_ssid_too_long: 'ssid过长',
        validate_safe_type: '请选择安全类型',
      },
      pushRecord: {
        btn_back: "返回",
        title_record: "操作记录",
        table_btn_check: "查看推送内容",
        table_btn_range: "查看推送范围",
        table_column_name: '配置名称',
        table_column_operator: '操作人',
        table_column_version: '版本号',
        table_column_push_range: '推送范围',
        table_column_operate_time: '操作时间',
        table_column_operate: '操作',
      },
      tableColumn: {
        push_status_unpushed: '未推送',
        push_status_unpushed1: 'TID/SN推送',
        push_status_push: '已推送',
        btn_record: '记录',
        column_config_name: '配置名称',
        column_push_status: '推送范围',
        column_finis_status: '完成状态',
        operation: '操作',
        column_push_type_all: '全局推送',
        column_push_type_part: '部分推送',
        query_finish_placeholder: '请输入机构名称关键字',
        query_finish_placeholder1: '请输入SN号关键字',
        query_finish_placeholder2: '请输入机构名称关键字，按下回车键执行搜索',
        query_finish_placeholder3: '请输入SN号关键字，按下回车键执行搜索',
        modal_title: '查询推送范围',
        modal_table_column: '机构名称',
        modal_table_column2: '是否生效',
        modal_table_column1: 'SN',
        finish_status_modal_title: '完成状态',
        finish_status_modal_search_placeholder: '请输入SN号/设备所属机构',
        finish_status_modal_re_push: '重新推送',
        finish_status_modal_re_push_msg: '重新推送配置成功',
        finish_status_modal_export: '导出报表',
        finish_status_modal_select_success: '执行成功',
        finish_status_modal_select_failure: '执行失败',
        finish_status_modal_select_unhandle: '未执行',
        finish_status_modal_table_column_org: '机构名称',
        finish_status_modal_file_name_success: '执行成功设备列表',
        finish_status_modal_file_name_failure: '执行失败设备列表',
        finish_status_modal_file_name_unhandle: '未执行设备列表',
        push_btn: '推送',
        push_modal_title: '选择推送范围',
        push_modal_cancel: '取消',
        push_modal_confirm: '推送',
        push_modal_validate: '请选择至少一个推送范围',
        push_modal_validate1: '操作成功',
        detail_modal_title: '查看配置详情',
        clone_btn: '克隆',
        delete_modal_msg: '删除该配置，将同时在设备上清除该配置，确认继续删除？',
        delete_modal_cancel: '取消',
        delete_modal_confirm: '删除',
      },
      deleteBash: {
        btn: '删除',
        modal_title: '批量删除配置',
        modal_tip: '删除这些配置，将同时在设备上清除这些配置，确认继续删除？',
        modal_btn_cancel: '取消',
        modal_btn_confirm: '删除',
      },
    },
    //wifi白名单
    wifiWhitelist:{
      wifi_whitelist_setting:'WIFI白名单设置',
      ssid:'SSID',
      pus_range:'推送范围',
      version:"版本",
      status:'状态',
      operate:'操作',
      not_push:'未推送',
      add_wifi_whitelist:'添加WIFI白名单',
      whitelist_ssid:'白名单SSID',
      whitelist_ssid_tip0:'请输入白名单SSID,不同SSID之间使用逗号分开,例:WIFI11,WIFI22,WIFI33',
      wifi_whitelist_config_edit_tip:'编辑WIFI白名单设置',
      wifi_whitelist_config_history_push:'Wifi白名单历史推送内容',
      wifi_whitelist_config_push:'WIFI白名单推送',
      push_wifi_whitelist_config_batch_tip:'推送WIFI白名单配置，是否推送？',
      wifi_whitelist_select_group_error:'请选择一个设备分组',
      wifi_whitelist_ssid:'白名单网络名称',
      wifi_whitelist_group_wifi_ssid:'分组中WIFI配置内的SSID',
      wifi_whitelist_group_wifi_ssid_new:'手动添加',
      wifi_whitelist_group_ssid_list:'WIFI 配置内的SSID',
      wifi_whitelist_look_more:'查看更多',
      wifi_whitelist_name_default:'我的WIFI白名单',
      wifi_whitelist_name_is_exists:'请输入规则名称',
      wifi_whitelist_push_range_is_exists:'请选择推送范围',
      wifi_whitelist_ssid_name_is_exists:'请添加白名单wifi的网络名称',
      wifi_whitelist_ssid_empty:'无信息',
      already_push:'已推送'
    },
    //apn配置
    apnConfig: {
      tab_name: 'APN配置',
      addOne: {
        modal_title_one: '添加APN配置',
        modal_title_one1: '编辑APN配置',
        modal_title_two: 'APN配置详情',
        form_config_name: '配置名称',
        form_apn_name: 'APN名称',
        form_agent: '代理',
        form_port: '端口',
        form_username: '用户名',
        form_password: '密码',
        form_server: '服务器',
        form_mmsagent: '彩信代理',
        form_mmsport: '彩信端口',
        form_authentication_type: '身份验证类型',
        form_apn_type: 'APN类型',
        form_apn_protocol: 'APN协议',
        form_btn_ok: '添加',
        form_btn_ok1: '编辑',
        validate_port: '请输入正确的端口号',
        validate_config_name: '请输入配置名称',
        validate_apn_name: '请输入APN名称',
        validate_apn: '请输入APN',
        validate_mcc: '请输入MCC',
        authentication_type_null: '无',
        validate_mnc: '请输入MNC',
    },
      delete: {
        title: '删除配置'
      },
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        apn_name: 'APN名称',
        push_type: '推送范围',
        push_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
      }
    },
    //文件分发
    file_distribution: {
      view_title:'文件分发查看',
      device_groupDevice_fileDistribution:'创建文件分发',
      device_groupDevice_fileDistribution1:'编辑文件分发',
      device_groupDevice_tip7:'查看推送内容',
      device_groupDevice_tip10:'如上为设备端文件存储的指定路径!',
      device_groupDevice_fileUpload:'文件上传：',
      device_groupDevice_uploadFile:'上传文件',
      device_groupDevice_tip8:'文件大小不超过100M,文件分发后不可撤回,请慎重!',
      device_groupDevice_targetPath:'目标路径：',
      device_groupDevice_fileRule:'文件规则：',
      device_groupDevice_coverOriginal:'覆盖原有文件',
      device_groupDevice_tip12:'下载成功后提示对方',
      device_groupDevice_tip15:'请上传需要分发的文件!',
      device_groupDevice_tip16:'请输入正确的目标路径!',
      device_groupDevice_tip17:'请输入配置名称',
      operation_success:'操作成功',
      file_send_size_rule : '导入文件不得超过100MB',
      tab_name:"文件分发",
      add:"添加",
      delete:"删除",
      upload_file:'文件上传',
      target_path:'目标路径',
      file_rule:'文件规则',
      cover_file:'覆盖原有文件',
      tip_user:'下载成功后提示对方',
      config_name:'配置名称：',
      download_file:'原文件',
      enter_config_name:'请输入规则名称',
      param_version:"版本号："
    },
    //功能设置
    function_setting:{
      default_name:'功能设置',
      column_name:'配置名称',
      push_range:'推送范围',
      push_status:'推送状态',
      finish_status:'完成状态',
      operation:'操作',
      add_modal_title:'功能设置添加',
      edit_modal_title:'功能设置编辑',
      view_function_title:'查看功能设置',
      tab_name:'功能设置',
      add_rule:'添加',
      delete_rule:'删除',
      view_functionSetting:'查看功能设置',
      rule_name:"规则名称：",
      fcSetting_home_disable: "禁用Home键：",
      fcSetting_dropDown_disable: "禁用下拉状态栏：",
      fcSetting_bluetooth_disable: "禁用蓝牙：",
      fcSetting_wifi_disable: "禁用WIFI",
      fcSetting_ThirdPartyApplicationInstallation_disable: "禁用第三方应用安装：",
      fcSetting_usb_disable: "禁用USB：",
      fcSetting_input_disable: "禁用输入法弹出：",
      button_confirm:'确定',
      button_cancel:'取消',
      operation_success : '操作成功',
      function_ruleName:"规则名称不能为空",
      yes: '是',
      no : '否',
      no_handle:"不处理",
      on:'开启',
      off:'关闭',
      deploy_operation_success:'操作成功',
      device_donaterecord_all:'全部',
      uploadapk_upload1 : '准备上传: ',
      uploadapk_upload2 : '上传中: ',
      device_remote_rule_name:"规则名称",
      device_remote_fcSetting_wifi_disable: "禁用WIFI：",
      device_remote_fcSetting_allow_uninstall:'允许卸载：',
      device_remote_fcSetting_allow_permission:'允许应用权限：',
      device_remote_fcSetting_gms_disable:"禁用GMS：",
      device_remote_fcSetting_nfc_permission:'禁用NFC：',
      device_remote_fcSetting_camera_permission:'禁用相机：',
      device_remote_fcSetting_camera_disable: "禁用相机",
      customDeskNameNotSame:'配置名称不可重复',
      function_pushRange:"请选择至少一个推送范围",
      close:'关闭',
      device_sn : '设备SN号',
      reminder :'温馨提示',
      selectmoreone : '请至少选择一项',
      setSilentAppModel:'设置为默启',
      silent_query_appname:'请输入应用名称',
      devType:'机型' ,
      time_input:'轮询时间只能输入整数,最小为5分钟且不能超过24小时（即1440分钟）',
      enterMessage:'请输入推送的消息',
      device_tip:'提示',
      device_forbidden_tip:'此操作将会禁用设备, 是否继续?',
      device_unforbidden_tip:'此操作将会解禁设备, 是否继续?',
      param_version:"版本号："
    },
    //地理围栏
    address_fence:{
      tab_name:'地理围栏',
      rule_name:'规则名称',
      fences_range_lng:'围栏经度',
      fences_range_lat:'围栏纬度',
      fences_range_radius:'围栏半径',
      meter:'米',
      fence_switch:"围栏开关",
      close:"关闭",
      open:"开启",
      out_of_range_limit:'超出范围限制',
      device_disabled:'设备禁用',
      add:'添加',
      delete_rule:'删除',
      push_content111:'推送内容',
      table_rule_name:'配置名称',
      table_fence:'围栏',
      table_push_range:'推送范围',
      table_status:'状态',
      table_operate:'操作',
      ring_pwd : '密码必须为四位数字',
      device_fence_cricle_center_lng:'围栏中心经度必须是数值，取值在-180~180之间',
      device_fence_cricle_center_lat:'围栏中心纬度必须是数值，取值在-90~90之间',
      device_fence_cricle_center_radius:'围栏半径必须是数值，且必须大于0',
      device_fence_circle_frequency_param_error:'发送频率只能是正整数',
      device_fence_circle_name_param_error:'规则名称不能为空',
      device_fence_circle_mail_error:'邮箱格式错误',
    },
    //消息推送
    messagePush:{
      tab_name: '消息推送',
      edit: '消息推送编辑',
      addOne: {
        modal_title_one: '添加推送消息',
        modal_title_two: '推送消息详情',
        validate_config_name: '请输入配置名称',
        validate_message:'请输入推送的消息',
        form_config_name: '配置名称：',
        form_message: '推送消息：',
      },
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        push_message:'消息内容',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
      }
    },
    //应用卸载
    unInstallDeviceApp:{
      tab_name: '应用卸载',
      addOne: {
        modal_title_one1: '编辑卸载应用',
        validate_config_name: '请输入配置名称',
        form_config_name: '配置名称',
        form_message: '卸载应用',
        device_groupDevice_uninstallApp:'卸载应用 一次仅可卸载一个应用',
        device_groupDevice_configName:'配置名称：',
        device_groupDevice_uninstallType:'卸载方式：',
        device_groupDevice_configName_input:'请填写配置名称',
        device_groupDevice_uninstallType1:'按应用名卸载',
        device_groupDevice_uninstallType2:'按包名卸载',
        device_groupDevice_tip5:'请选择应用名称',
        device_groupDevice_config_version:'版本号：',
        device_groupDevice_tip3:'填写要卸载的应用包名，仅限一个(例如：ffsdsssd.dasdasd.sadasd)',
        device_groupDevice_tip4:'请确认包名的准确性',
        device_groupDevice_appPackageName:'应用包名：',
        device_groupDevice_tip17:'请输入要卸载的应用包名',
        device_groupDevice_tip18:'请选择要卸载的应用名称',
        device_groupDevice_appName:'应用名称：',
        validate_message:'请输入应用包名',
        validate_message_appname:'请选择应用名称'
      },
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        unInstallType:'卸载方式',
        unInstallPackageName:'卸载应用',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        unInstallType_Name1:'按应用名卸载',
        unInstallType_Name2:'按包名卸载',
        operation: '操作',
      }
    },
    //密码下发
    lockScreenPassword:{
      tab_name: '密码下发',
      add_password: '新增密码规则',
      edit_password: '编辑密码规则',
      view_password: '查看密码规则',
      config_name: '配置名称',
      password_type: '密码类型',
      lock_screen_password: '锁屏密码',
      dynamic_password: '动态密码',
      validate_config_name: '请输入配置名称',
      validate_password_null:'请输入密码',
      validate_password: '请输入6-12位数字密码',
      select_both:'全下发',
      select_lock_screen_password:'锁屏密码下发',
      select_dynamic_password:'动态密码下发',
      table: {
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        lock_screen_password:'锁屏密码',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
      }
    },
    //广告
    advertisement:{
      tab_name: '广告',
      edit: '编辑广告',
      addOne: {
        modal_title_one: '添加广告',
        modal_title_adv_details: '广告详情',
        form_adv_config_name: '配置名称：',
        validate_form_adv_config_name: '请输入配置名称',
        validate_form_adv_image_header: '请上传Image Header,类型为jpg、png、jpeg',
        validate_form_adv_image_slider:'请上传Image Slider,类型为jpg、png、jpeg',
        viewAdvPic:'查看图片',
        form_adv_image_header:'Image Header：',
        addSlider:'添加Slider',
        deleteSlider:'删除',
        uploadImageHeader:'上传Header',
        uploadSliderPic:'上传Slider',
        adv_content_max_size_is_8:'Slider最大个数为8个',
        adv_content_is_have_one:'至少有一个Slider',
        adv_header_imge_size:'请上传Image Header',
        adv_slider_imge_size:'请上传Image Slider',
        upload_image_format_error:'只能上传jpg、png、jpeg格式的图片'
      },
      table: {
        push_modal_title_adv_details: '推送广告详情',
        handle_status_pushed: '已推送',
        handle_status_unpushed: '未推送',
        view: '查看',
        config_name: '配置名称',
        push_type: '推送范围',
        handle_status: '推送状态',
        finish_status: '完成状态',
        operation: '操作',
      }
    },
    //ota
    ota:{
      menu: {
        add_os: '上传OS镜像',
        add_reg: '添加',
        update_reg: '修改',
        push:'推送',
        stop:'禁用',
        enable: '已推送',
        disable: '已禁用',
        toBePush: '待推送',
        download_template: '下载模板',
        records: '查看升级记录',
      },
      data:{
        selectSn: '输入或者选择SN号',
        msgStatus: '消息记录',
        yes: '是',
        no: '否',
        change_reg: '推送规则',
        push: '推送',
        change_status: '更改状态',
        status: '状态',
        os_id: 'OS编号',
        dev_type: '设备类型',
        records_os_type: 'OS 类型',
        model: '硬件配置',
        standard: '定制类型',
        os_version: '版本号',
        language: '语言',
        bag_type: '包类型',
        high_version: '基础版本',
        upload_date: '上传时间',
        isForce: '是否强制更新',
        isSilent: '是否静默更新',
        isImmediate: '是否立即更新',
        period: '更新时间段',
        remind: '更新提醒',
        remarks: '备注',
        osUrl: 'OS下载地址',
        chinese: '中文',
        english: '英文',
        change_status_success: '操作成功',
        change_status_failed: '操作失败',
        push_succcess: '已生效并推送',
        return_tip:'提示',
        return_msg:'确定返回吗？',
        clear_snRegMsg:'确认清空所有SN吗？',
        url: '下载地址',
      },
      addos:{
        version_rules:'版本规则',
        view_version_tips:'查看规则',
        basic_os:'基础OS版本',
        basic_os_tip: '增量更新包需填写此项',
        upload_package: '上传包',
        upload_package_tip: '上传包（仅支持.zip格式）',
        complete_package: '完整更新包',
        incremental_package: '增量更新包',
        timePick: '时间段',
        datePick: '日期时间段',
        save: '保存',
        clear: '清空',
        back: '返回',
        addos_success: '上传OS镜像成功',
        validate_failed:'请检查输入的数据是否正确',
        devType_msg: '设备类型不能为空',
        model_msg: '硬件配置不能为空',
        standard_msg: '定制类型不能为空',
        osVersion_empty_msg: '版本不能为空',
        osVersion_msg: '版本格式有误,请输入(安卓版本.YY.MMDD.xx)格式!',
        bagType_empty_msg: '更新包类型不能为空',
        path_empty_msg: '请选择文件',
        path_format_error_msg: '文件格式错误',
        file_too_large: '文件过大，不能超过8GB',
        highVersion_empty_msg: '增量更新包需填写基础OS版本',
        select_empty: '请选择',
        period_empty: '时间段不能为空',
        remind_empty: '静默更新选择否时，需填写更新提醒!',
        osVersion_format_msg: '请先填写正确的版本号',
        basic_os_error: '基础OS版本必须低于OS版本号',
        //后端错误信息
        filename_notfound:'未找到文件名',
        file_format_error: '文件格式错误',
        empty_file: '更新包为空文件，无法导入',
        unzip_file_failed: '文件解压失败，请重新选择文件',
        upload_oss_failed: '文件上传OSS失败',
        file_transfer_failed: '文件转化失败',
        file_save_failed: '文件上传服务器失败',
        request_failed: '请求失败',
      },
      delos:{
        select_item: '请至少选择一项',
        confirmed_del:'确认删除',
        delete_success: '成功删除',
        item: '项',
      },
      snReg:{
        push_by_sn: '按SN推送',
        push_by_org: '按节点推送',
        input_sn: '请输入SN',
        add_sn: '添加',
        import_sn: '导入',
        back: '返回',
        save: '保存',
        selectAll: '全选',
        save_success: '保存成功',
        add_error_msg: '设备不在本机构下或不存在',
        clear: '清空',
        added_sn: '已添加的SN',
        num: '序号',
        action: '操作',
        delete: '删除',
        os_info: '当前OS信息',
      },
      validateSN:{
        sn_duplicate: '重复',
        sn_validate: 'SN只能由字母和数字组成,且不能为空'
      },
      importSN:{
        import_file: '导入文件',
        select_file: '选择文件 (.txt文件)',
        tips1: '*只能上传.txt文件',
        tips2: '*建议每行填写一个SN',
        tips3: '*若一行填写多个，则用","隔开',
        fileMaxSize: '文件大小超出限制',
        fileUploadError: '文件上传出错',
        fileFormatError: '文件格式错误',
        import_success: '成功导入',
        item: '条',
        cancel: '取消'
      },
      records:{
        osVersion: 'OS版本号',
        updateResult: '升级结果',
        btnSearch: '查询',
        btnReset: '重置',
        btnBack: '返回',
        recordedTime: '记录时间',
        success: '成功',
        failed: '失败',
      }
    },
    //设备生命周期
    deviceLifeCycle: {
      overview: '设备数据总览',
      overview_input: '已录入设备(台)',
      overview_register: '已激活设备(台)',
      search_form_sn: 'SN:',
      search_form_dvcType: '设备类型:',
      search_form_inputTime: '录入时间:',
      search_form_registerTime: '激活时间:',
      search_form_btn_search: '查询',
      search_form_btn_export: '导出',
      table_column_sn: 'SN',
      table_column_sn_placeholder: '请输入SN号',
      table_column_dvcType: '设备类型',
      table_column_dvcType_placeholder: '请选择设备类型',
      table_column_inputTime: '录入时间',
      table_column_registerTime: '激活时间',
      table_column_inputTime_createDate:'请选择录入时间',
      table_column_inputTime_registerDate:'请选择激活时间',
      table_column_orgName: '当前所属机构(商户)',
    },
    //日志管理
    logManage:{
      log_add:"新建日志任务",
      sn:"SN",
      sn_tip:"请输入SN",
      device_type:"机型",
      device_type_tip:"请选择机型",
      task_time:"任务时间",
      task_time_tip:"请选择时间范围",
      status:"状态",
      status_tip:"请选择状态",
      status_finish:"已完成",
      status_push:"推送中",
      status_execution:"执行中",
      status_no_response:"终端无响应",
      status_forced_stop:"强制终止",
      status_file_is_not_exists:"文件不存在",
      operate_download_log:"下载日志",
      operate_reset:"重试",
      operate_force_stop:"终止操作",
      table_sn:"SN",
      table_device_type:"机型",
      table_remark:"设备备注",
      table_log_type:"日志类型",
      table_create_time:"创建时间",
      table_start_time:"开始时间",
      table_end_time:"结束时间",
      table_status:"状态",
      table_operate:"操作",
      log_file_path:"文件路径",
      log_type_utms:"UTMS日志",
      log_type_system:"系统日志",
      log_type_file:"指定文件",
      log_type_utms_path:"/sdcard/UTMS/Log",
      log_type_system_path:"/sdcard/Ulog/logs/adb",
      log_type_utms_tip_1:"此操作将要提取设备日志，是否继续？",
      log_type_utms_tip_2:"日志文件上传需要一定时间，完成后，在日志记录中下载。",
      log_type_system_start_time:"开始时间",
      log_type_system_continued_time:"持续时间",
      log_type_system_log_main:"main日志",
      log_type_system_log_main_tip:"(内核及root权限操作日志)",
      log_type_system_log_radio:"radio日志",
      log_type_system_log_radio_tip:"(射频通讯模块通讯日志)",
      log_type_system_log_system:"system日志",
      log_type_system_log_system_tip:"(操作系统日志)",
      log_type_system_log_events:"events日志",
      log_type_system_log_events_tip:"(事件日志，例触屏点击事件等)",
      log_type_system_file_size:"文件限制",
      log_type_system_file_rule:"文件规则",
      log_type_system_file_rule_1:"上传后删除文件",
      log_type_system_file_rule_2:"上传后通知设备",
      log_type_system_start_time_type_tip:"请选择开始时间",
      log_type_system_continued_time_tip:"请输入持续时间",
      log_type_system_continued_time_tip1:"持续时间必须在1-100之间",
      log_type_system_continued_time_tip2:"请选择时间单位",
      log_type_system_record_log_tip:"请勾选日志记录类别",
      log_type_system_file_size_tip:"请输入文件限制",
      log_type_system_file_size_tip1:"文件限制必须在0-200之间",
      log_type_file_path:"目标路径",
      log_type_file_path_format:'格式如:/sdcard/MDM',
      log_type_file_path_tip:"如上为设备端文件存储的指定路径",
      log_type_file_file_rule:"文件规则",
      log_type_file_file_rule_1:"上传后删除文件",
      log_type_file_path_error_tip:"请输入目标路径",
      log_type_file_path_error_tip1:"目标路径不合法,请输入合法路径",
      log_time_min:"分",
      log_time_hour:"小时",
      log_time_day:"天",
      add_table_sn:"SN",
      add_table_device_type:"机型",
      add_table_status:"状态",
      add_table_add_tip:"请在左侧表格选择数据",
      add_table_remove_tip:"请在右侧表格选择数据",
      modal_add_log:"提取设备日志",
      modal_select_device:"选择设备",
      modal_log_task:"日志任务",
      modal_button_add:"添加",
      modal_button_cancel:"取消",
      modal_button_next:"下一步",
      modal_button_sure:"确定",
      device_status_on:"在线",
      device_status_off:"离线",
      modal_tip_select_dvcId_empty:"选择设备数为空",
      tip_content_forced_stop:"此操作将停止采集日志，是否继续?",
      tip_content_reset:"此操作将重新推送日志采集，是否继续?",
      log_download:'下载',
      tip:"提示",
    },
    remoteManage:{
      shutdown :  '关机',
      restart: '重启',
      uninstallApp: '卸载应用',
      documentDistribution: '文件分发',
      deviceInfo: '设备信息',
      nativeInfo: '本机信息',
      dvcType:'机型',
      snNumber: 'SN号',
      sn_jd:'SN号',
      jd_device_info:'设备信息',
      sysVersion: 'OS版本',
      seVersion: 'SE版本',
      ufsVersion: 'UFS版本',
      basebandVersion: '基带版本',
      kernelVersion: '内核版本',
      screenResolution: '屏幕分辨率',
      currentPosition: '当前位置',
      dvcMemory: '设备内存',
      storage: '存储',
      SIMCardNum: 'SIM卡序列号',
      operator: '运营商',
      IPAddress:'IP 地址',
      psam:'PSAM序列号',
      unknown:'未知',
      china_mobile:'中国移动',
      china_unicom:'中国联通',
      china_telecom:"中国电信",
      china_tietong:"中国铁通",
      total_length_printed:'打印总长度',
      swipping_card_times:'刷卡次数',
      dip_insert_times:'插卡次数',
      nfc_card_read_times:'NFC卡读取次数',
      front_camera_openTimes:'前置摄像头开启次数',
      rear_camera_open_times:'后置摄像头开启次数',
    },
    remoteConfig:{
      function_control:'功能设置',
      ssid:'SSID',
      wifi_whitelist_setting:'WIFI白名单设置',
      name:'名称',
      type:'类型',
      pus_range:'推送范围',
      status:'状态',
      execution_progress:'执行进度',
      operate:'操作',
      select_push_range:'选择推送范围',
      apn_name:'APN名称',
      apn:'APN',
      agent:'代理',
      port:'端口',
      user_name:'用户名',
      password:'密码',
      server:'服务器',
      mmsc:'MMSC',
      mms_agent:'彩信代理',
      mms_port:'彩信端口',
      mcc:'MCC',
      mnc:'MNC',
      authentication_type:'身份验证类型',
      apn_type:'APN类型',
      empty_null:'无',
      apn_protocol:'APN协议',
      not_push:'未推送',
      already_push:'已推送',
      qr_code_generate_tip:'请填写设置信息后再生成二维码',
      qr_code_generate:'生成二维码',
      qr_code_generate_new_tip:'点击生成WIFI连接二维码，设备端可通过扫描二维码，连接对应的网络',
      config_push:'推送',
      config_edit:'编辑',
      yes:'是',
      no:'否',
      add_wifi_whitelist:'WIFI白名单添加',
      whitelist_ssid:'白名单SSID',
      whitelist_ssid_tip0:'请输入白名单SSID,不同SSID之间使用逗号分开,例:WIFI11,WIFI22,WIFI33',
      wifi_whitelist_config_edit_tip:'编辑WIFI白名单设置',
      wifi_whitelist_config_history_push:'Wifi白名单历史推送内容',
      wifi_whitelist_config_push:'WIFI白名单推送',
      push_wifi_whitelist_config_batch_tip:'推送WIFI白名单配置，是否推送？',
      wifi_whitelist_select_group_error:'请选择一个设备分组',
      wifi_whitelist_ssid:'白名单网络名称',
      wifi_whitelist_group_wifi_ssid:'分组中WIFI配置内的SSID',
      wifi_whitelist_group_wifi_ssid_new:'手动添加',
      wifi_whitelist_group_ssid_list:'WIFI 配置内的SSID',
      wifi_whitelist_look_more:'查看更多',
      wifi_whitelist_name_default:'我的WIFI白名单',
      wifi_whitelist_name_is_exists:'请输入规则名称',
      wifi_whitelist_push_range_is_exists:'请选择推送范围',
      wifi_whitelist_ssid_name_is_exists:'请添加白名单wifi的网络名称',
      wifi_whitelist_ssid_empty:'无信息',
    },
    manufacturer:{
      confirm:'确定',
      cancel:'取消',
      enter_manufacturer_dvc_type:'最大25个字符',
      remove_manufacturer_type_tip1:'确定要删除',
      remove_manufacturer_type_tip2:'型号吗？',
      remove_manufacturer_tip1:'确定要删除',
      manufacture_name_empty:'厂商不能为空',
      dvc_type_empty:'设备类型不能为空',
      dvc_type:'设备型号:',
    },
    pushDisplay:{
      range:{
        group_push:"分组推送",
        sn_push:"SN推送",
        table:{
          sn:"SN",
          group_name:"分组名称",
          device_type:"设备类型",
        },
        tip:{
          input_sn:"请输入SN",
        }
      },
      schedule:{
        execution_progress:"执行进度",
        status:{
          un_finish:"未完成",
          finish:"已完成",
          finish_failure:"执行失败",
          finish_stop:"终止操作",
        },
        table:{
          sn:"sn",
          execution_status:"执行状态",
          group_name:"设备分组",
          implementation:"执行情况",
        },
        tip:{
          search_status_tip:"请选择执行状态",
          search_sn_tip:"请输入设备SN",
        },
        button:{
          query:"查询",
          export_excel:"导出报表",
        }
      },
    },
    rule:{
      rule_name:'名称',
      rule_version:'版本号',
      operate_user:'操作员',
      version:'版本号',
      push_circle:'查询推送范围',
      operate_time:'操作时间',
      operate:'操作',
      view_push_content:'查看推送内容',
      pushRange:'查看推送范围',
      operate_record:'操作记录',
      record_return:'返回',
      record_content:'推送内容',
      record_modal_close:'关闭',
      app_deploy:'应用部署',
      unfinish_sn:'未完成SN号',
      unfinish_title:'完成状态',
      sn:'SN',
      dvc_org:'设备所属机构',
      schedule:'完成度',
      sn_own_group:'设备所属分组',
      has_push_group:'机构名称',
      has_push_status:'已推送',
      will_push_status:'未推送',
    },
    warning: {
      fence_title: '设备围栏告警',
      device_lng: '设备经度',
      device_lat: '设备维度',
      fence_lng: '围栏经度',
      fence_lat: '围栏维度',
      fence_radius: '围栏半径',
    },
  },
  //系统定制
  system_custom: {
    silent_app:{
      application_name:'应用选择',
      default_config_name:'默启应用',
      part_push:'部分推送',
      all_push:'全局推送',
      has_pushed:'已推送',
      no_push:'未推送',
      table_column_config_name:'配置名称',
      table_column_app_name: '默启应用',
      table_column_push_range:'推送范围',
      table_column_push_status:'推送状态',
      table_column_finis_status:'完成状态',
      table_column_operation:'操作',
      add_modal_title_name:'添加默启应用',
      edit_modal_title:'编辑默启应用',
      view_modal_title:'查看默启应用',
      add_rule:'添加',
      delete_btn_rule:'删除',
      view_silent_app:'查看默启应用',
      rule_app_name:"规则名称",
      silentApp_version:"版本号",
      confirm_button:'确定',
      cancel_button:'取消',
      push_operation_success : '操作成功',
      validate_configName_empty:"规则名称不能为空",
      form_application_version:'版本',
      validate_app_select_empty:'默启应用不能为空',
      config_name_no_more_than:'规则名称不超过32字符',
      modal2_title:'选择默启应用',
      tableColumn: {
        push_status_unpushed: '未推送',
        push_status_unpushed1: 'TID/SN推送',
        push_status_push: '已推送',
        btn_record: '记录',
        column_config_name: '配置名称',
        column_push_status: '推送范围',
        column_finis_status: '完成状态',
        operation: '操作',
        column_push_type_all: '全局推送',
        column_push_type_part: '部分推送',
        modal_title: '查询推送范围',
        modal_table_column: '机构名称',
        modal_table_column2: '是否生效',
        modal_table_column1: 'SN',
        finish_status_modal_title: '完成状态',
        finish_status_modal_search_placeholder: '请输入SN号/设备所属机构',
        finish_status_modal_re_push: '重新推送',
        finish_status_modal_re_push_msg: '重新推送配置成功',
        finish_status_modal_export: '导出报表',
        finish_status_modal_select_success: '执行成功',
        finish_status_modal_select_failure: '执行失败',
        finish_status_modal_select_unhandle: '未执行',
        finish_status_modal_table_column_org: '机构名称',
        finish_status_modal_file_name_success: '执行成功设备列表',
        finish_status_modal_file_name_failure: '执行失败设备列表',
        finish_status_modal_file_name_unhandle: '未执行设备列表',
        push_btn: '推送',
        push_modal_cancel: '取消',
        push_modal_confirm: '推送',
        push_modal_validate: '请选择至少一个推送范围',
        push_modal_validate1: '操作成功',
        detail_btn: '查看',
      },
    },
    customDesk:{
      cusDeskType:'桌面类型',
      version:'版本',
      name : '配置名称',
      empty_custom_desk_tip:'请填写配置名称',
      empty_custom_desktop_tip:'请填写桌面名称',
      stand_template:'标准模板',
      stand_template_tips:'注意：使用标准模板时，请确保设备安装了企业桌面App',
      custom_template_file:'自定义模板文件(请上传apk格式文件最大支持100M)',
      submit:'确定添加',
      download_config:'下载已经配置的文件',
      default_cus_name:'我的自定义桌面规则',
      default_apk_name:'我的应用包名',
      upload_desktop_app:'请上传自定义桌面应用',
      upload_config_file:'请上传配置文件',
      admin_password_is_not_null:'管理员密码不能为空',
      app_package_is_not_null:'应用包名不能为空',
      admin_password_error_tip:'管理员密码不能有中文',
      upload_wallpaper_error:'请上传壁纸文件',
      add_package_name_tip:'可支持多个应用显示在桌面，不同应用包名直接用“,”分隔',
      custom_config_file:'请上传已配置好的企业模式profile',
      custom_wallpaper:'请上传壁纸(只允许jpg,jpeg,png格式图片)',
      export_settings_property_json_description:'请在模板机上将企业模式完成配置后导出。导出的文件保存在sdcard/Custom_Local_Server目录下的 settings_property.json。可将此json文件通过utms下发。',
      customizeTemplate:'自定义模板',
      normalTemplate:'标准模板',
      configMethod:'配置方式',
      uploadWallpaper:'壁纸上传',
      configFileUpload:'配置文件上传',
      wallpaperUpload:'上传壁纸',
      noWallpaperUpload:'不上传壁纸',
      normalConfig:'标准配置',
      wallpaperName:'壁纸',
      configName1:'settings_property.json',
      desktopName:'桌面名称',
      adminPassword:'管理员密码',
      desktopAppPackage:'桌面应用包名',
      appIconSize:'应用图标大小',
      small:'小',
      normal:'常规',
      nax:'大',
      oversized:'超大',
      table_column_config_name:'配置名称',
      table_column_apk_name:'桌面名称',
      add_modal_title_one1:'编辑自定义桌面',
      add_modal_title_two:'自定义桌面详情',
      add_modal_config_name:'配置名称',
      add_modal_config:'配置方式',
      add_modal_apk: '模板文件',
      custom_desk_add:'自定义桌面添加',
      table_push_type:'推送范围',
      table_push_status:'推送状态',
      table_finish_status:'完成状态',
      table_operation:'操作',
    },
    occupyScreen: {
    add: {
      title: '创建霸屏应用',
      title1: '编辑霸屏应用',
      form_name: '配置名称',
      form_name_placeholder: '请输入配置名称',
      form_push_range: '推送范围',
      form_push_range_placeholder: '请选择推送范围',
      form_push_range_btn: '推送范围',
      form_pwd: '解锁密码',
      form_pwd_placeholder: '请输入解锁密码(4位数字)',
      form_app: '应用选择',
      form_cancel: '取消',
      form_create: '创建',
      form_edit: '编辑',
      form_app_version: '版本:',
      modal_title: '选择推送范围',
      modal_cancel: '取消',
      modal_confirm: '确定',
      modal1_title: '选择霸屏应用',
      modal1_search: '应用名称',
      modal1_select: '选择应用',
      validate_name_empty: '配置名称不能为空',
      validate_orgName_empty: '推送范围不能为空',
      validate_lockPwd_empty: '解锁密码不能为空',
      validate_lockPwd_er: '请输入4位数字密码',
      validate_app_empty: '霸屏应用不能为空',
      msg_add_success: '添加配置成功',
      msg_edit_success: '编辑配置成功',
    },
    table: {
      column_config_name: '配置名称',
      column_occupy_app_name: '霸屏应用',
      column_push_range: '推送范围',
      column_status: '状态',
      column_finish_status: '完成度',
      column_operation: '操作',
      column_push: '推送',
      show_detail: '查看',
      show_modal_title: '霸屏应用详情',
    },
    },
    bootAnimation:{
    tab_name:"开机动画",
    delete_rule:"删除",
    btn_name_add:"添加",
    table_rule_name:"配置名称",
    table_rule_version:"配置版本",
    table_rule_push_range:"推送范围",
    table_rule_push_status:"推送状态",
    table_rule_finish_status:"完成状态",
    table_rule_create_time:"创建时间",
    table_rule_update_time:"修改时间",
    table_rule_operate:"操作",
    table_rule_animation_type:"动画类型",
    push_range_group:"分组推送",
    push_range_tid_sn:"TID/SN推送",
    push_range_all:"全局推送",
    handle_status_unpushed:"未推送",
    handle_status_pushed:"已推送",
    animation_type_default:"默认动画",
    animation_type_zip:"上传压缩包",
    clone_tip:'您将要克隆此开机动画,是否继续?',
    error_upload_file_format_size:"上传文件需zip文件，且最大20M",
   },
    bootAni:{
      select_zip:'选择ZIP包',
      zip_rule:'图片制作规则',
      download_boot_temp:'下载模板',
      boot_load_ing:'开机动画预览文件正在生成，请耐心等待。',
      boot_join_ing:'加载中...',
      zip_parse_fail:'ZIP解析失败',
      zip_parse_fail_desc:'ZIP解析失败，具体请参照模板以及ZIP制作规则。',
      select_true:'确定',
    },
  tip:{
    mustApk:'文件类型不正确，请上传APK文件',
    mustFile:'文件类型不正确，请上传JSON文件',
    cus_max_size:'最大上传100MB文件',
    fileTypeNotSupport:'文件类型不支持',
  },
  },
  //策略管理
  policy_manage: {
    policyManagement: '策略管理',
    configurationManagement: '配置管理',
    configureManage:{
      button:{
        upload_config:'上传配置',
        generate_barcode:'生成条码',
        publish:"发布",
        delete_config:"删除",
        cancel:"取消",
        save:"确定",
     },
      table:{
        table_name:'配置管理',
        configName:'配置名称',
        configRuleType:"配置类型",
        version:"规则版本号",
        pushType:"推送范围",
        pushStatus:"状态",
        executionProgress:"执行进度",
        createTime:"创建时间",
        updateTime:"上次修改时间",
      },
      type:{
        scan_head:'扫描头设置',
        system:'系统设置',
        scan_and_system:'扫描头设置和系统设置',
      },
      status:{
        pushed:'已发布',
        not_pushed:'未发布',
      },
      modal:{
        head:'上传配置',
        barcode_generate:'条码生成',
        upload_file:'上传配置文件:',
        upload_file_tip:'支持文件格式: txt',
        upload_file_format_tip:'上传文件格式错误,请上传txt格式文件',
        upload_file_size_tip:'请上传小于100KB的txt文件',
        barcode_tip:'打开终端U stage扫描二维码下配置文件',
        barcode_down:'下载二维码到本地',
        delete_tip:"您将删除选择的配置，是否继续?",
        configName:'配置名称:',
        configRuleType:"配置类型:",
      },
      tip:{
        select_one_row:"请选择一条规则",
        select_more_one_row:"仅可选择一条规则",
        select_delete_row:"请选择需要删除的数据",
        add_tip:"请上传配置文件",
        top_tip_1:"1、 上传配置：使用终端应用：UStage - 导出配置文件（UStage可通过应用市场上架并下载），将此配置文件上传。使用上传配置可通过UTMS发布，终端联网后自动下载并生效配置。",
        top_tip_2:"2、 终端上传：使用终端应用：UStage - 上传至UTMS，可同步该设备的配置到UTMS后台。使用终端上传，会自动生成一条规则，可通过UTMS发布。",
      }
    },
  },
  //流量管理
  flow_manage: {
    flowManagement:'流量管理',
    flow_manage:'流量管家',
    flowLimitWarn:"限额提醒",
    flowManage:{
      device_type : '设备类型',
      device_sn : '设备SN号',
      task_time_tip:"请选择时间范围",
      device_distribute_enterSn:'请输入SN号',
      detail:'详情',
      flowUsage:'流量使用情况',
      appRank:'应用排行',
      groupRank:'机构商户排行',
      exportReport:'导出报表',
      date:'日期',
      start_date:'开始日期',
      end_date:'结束日期',
      totalUsage:'总消耗流量',
      dayUsagePerDvc:'每台设备日均流量',
      rank:'排行',
      org:'机构',
      parentOrg:'所属父机构',
      percent:'占比',
      operate:'操作',
      appName:'应用名称',
      appPackage: '应用包名',
      periodTotalFlow:'期间总流量',
      dvcNum:'设备数',
      periodDayFlow:'期间日均流量',
      dvcDayFlow:'每台设备日均流量',
      periodOrgFlowUsage:'所选机构期间设备的流量使用情况',
      periodAppFlowUsageRank:'期间该设备应用使用流量排行',
      dvcSnCode:'设备SN号',
      selectOrg:'请选择机构',
      unitMb:'单位：Mb',
      selectRankOrg:'选择进行排行的机构',
      childGroupUsageDetail:'子机构流量详情',
      currentOrg:'当前机构',
      selectTwoMoreOrg:'勾选的机构不得少于2个',
      nought:'无',
      allOrg:'全部机构',
      selectDay:'请选择日期',
      startDayBeforeEndDay:'开始日期不能大于结束日期',
      flowLimit:{
        tip: {
          search_tip: "请输入SN",
  },
        modal:{
          flow_limit_tip:"流量限额提醒",
          limit_tip:"当天流量消耗超过设定值时，记录并警示",
          limited_amount_day:"当天限定额度",
          limit_error_tip:"请输入1~9999之间的整数",
        },
        button:{
          limit_setting:"限额设置",
        },
        table:{
          sn:"SN",
          operate:"操作",
          record_time:"记录时间",
          flow_use:"当天流量使用量",
          flow_limit:"当天限定额度",
          warn:"警告",
          warn_tip:"流量已达上限",
        },
      },
    },
  },
  //基础设置
  base_setting: {
    basesetting: '基础设置',
    platform_settings:'平台设置',
    operation_log: '操作日志',
    authorityManagement : '权限管理',
    otaParamManagement : 'OTA参数管理',
    platformSetting:{
      power_flow_config:'耗电&流量配置',
      high_precision_model:'高精度模式',
      balance_model:'均衡模式',
      energy_conservation_model:'节能模式',
      custom_model:'自定义模式',
      push_setting:'推送设置：',
      using:'使用',
      onUsing:'不使用',
      map_setting:'地图采用模式设置：',
      preciseness:'高精准',
      energy_conservation:'节能',
      polling_time_setting:'轮询时间设置：',
      power_cache_frequency_setting:'电量缓存频率：',
      network_connection_frequency:'网络信息缓存频率：',
      minute:'分钟',
      data_cache_setting:'数据缓存设置',
      data_cache_setting_power_clean:'电量信息有效期',
      data_cache_setting_log_clean:'操作日志有效期',
      data_cache_setting_day:'天',
      data_cache_setting_minute:'分钟',
      data_cache_setting_power_error_tip:'电量信息有效期范围为1-360天',
      data_cache_setting_power_error_tip_empty:'电量信息有效期不能为空',
      data_cache_setting_log_error_tip:'操作日志有效期范围为30-360天',
      data_cache_setting_power_cache_frequency:'电量信息缓存频率只能输入整数且不能超过24小时（即1440分钟）',
      data_cache_setting_net_connect:'网络连接信息缓存频率只能输入整数且不能超过24小时（即1440分钟）',
      data_cache_setting_log_error_tip_empty:'操作日志有效期不能为空',
      platform_setting_submit:'应用',
  },
    operationLog: {
      search: {
        operator: '操作人：',
        operator_placeholder: '请输入操作人',
        module: '菜单：',
        module_placeholder: '请选择菜单',
        operateTime: '操作时间：',
        operateTime_placeholder: '请选择操作时间',
        handle_status: '操作结果：',
        handle_status_placeholder: '请选择操作结果',
        btn_search: '查询',
        btn_reset: '重置',
        operation_result_success: '成功',
        operation_result_fail: '失败',
      },
      table: {
        operator: '操作人',
        module: '菜单',
        operatorTime: '操作时间',
        content: '操作内容',
        result: '操作结果',
        result_succ: '成功',
        result_fail: '失败',
      }
    },
    authority: {
      form_header: '创建角色',
      form_header_edit:'编辑角色',
      role_name_label: '角色名称:',
      role_name_error1: '角色名称为必填字段',
      role_name_error2: '角色名称不能超过50个字符',
      placeholder_1: '请输入角色名称',
      remark_label: '备注:',
      is_default: '默认角色:',
      remark_placeholder: '请输入备注信息',
      remark_error1: '备注信息不能超过100个字符',
      form_btn_cancel: '取消',
      form_btn_OK: '确定',
      is_default_yes: '是',
      is_default_no: '否',
      tab_user: '用户',
      tab_role: '角色',
      tab_menu: '菜单',
      user_form_account: '账号',
      user_form_org: '所属机构/商户',
      user_form_role: '已拥有角色',
      user_form_option: '操作',
      allocate_modal_header: '分配角色',
      allocate_form_role_name: '角色名称',
      allocate_form_option: '操作',
      allocate_delete: '删除',
      allocate_cancel: '取消',
      allocate_ok: '确定',
      role_btn_create: '创建',
      role_btn_delete: '删除',
      role_column_isDefault_true: '是',
      role_column_isDefault_false: '否',
      role_btn_edit: '编辑',
      role_btn_allocate: '分配菜单',
      role_column_name: '角色名称',
      role_column_default: '默认角色',
      role_column_remark: '备注',
      role_column_option: '操作',
      role_column_create_time: '创建时间',
      role_column_update_time: '更新时间',
      role_column_create_user: '创建者',
      role_delete_title: '提示',
      role_delete_tip: '删除角色将导致拥有此角色的用户失去相应权限，确定删除吗？',
      role_allocate_modal_title: '分配菜单',
      role_allocate_modal_cancel: '取消',
      role_allocate_modal_ok: '确定',
      role_allocate_modal_error1: '请至少勾选一个菜单',
      role_allocate_title: '提示',
      role_allocate_tip: '确定要分配勾选的权限吗?',
      menu_tree_placeholder: '输入关键字进行过滤',
      menu_tree_all: '全选',
      menu_tree_parent: '父子关联',
      menu_detail_name: '菜单详情:',
      menu_form_parent_code: '父菜单编号:',
      menu_form_parent_name: '父菜单名称:',
      menu_form__code: '菜单编号:',
      menu_form_btn_select: '选择父菜单',
      menu_form_path: '菜单路径:',
      menu_form_auth: '校验字符串:',
      menu_form_remark: '备注:',
      menu_form_i18: '国际化字符串:',
      menu_form_order: '顺序值:',
      menu_form_edit: '编辑菜单',
      menu_form_create: '创建菜单',
      menu_form_delete: '删除菜单',
      menu_form_error1: '请选择父菜单',
      menu_form_edit_title: '提示',
      menu_form_edit_tip: '确定要提交更新?',
      menu_form_delete_tip: '确定要删除该菜单?',
      menu_selector_title: '选择菜单',
      menu_create_parent_placeholder: '请选择父菜单',
      menu_create_parent_placeholder1: '请选择父菜单',
      menu_create_path_placeholder1: '请输入菜单路径',
      menu_create_auth_placeholder1: '请输入校验字符串',
      menu_create_note_placeholder1: '请输入备注信息',
      menu_create_i18_placeholder1: '请输入国际化字符串',
      menu_create_order_placeholder: '请输入顺序数值',
      menu_create_title: '创建菜单',
      menu_form_path_val: '菜单路径不能为空',
      menu_form_path_val1: '菜单路径不能超过50个字符',
      menu_form_auth_val: '菜单校验字符串不能为空',
      menu_form_auth_val1: '菜单校验字符串不能超过50个字符',
      menu_form_i18_val: '国际化字符串不能为空',
      menu_form_order_val: '顺序数值不能为空',
      menu_form_order_val1: '顺序数值只能为数字',
      menu_form_i18_val1: '国际化字符串不能超过100个字符',
      menu_form_remark_val1: '备注信息不能超过100个字符',
      reset_password:'密码',
      reset_password_repeat:'重复密码',
      enter_password: '请输入密码',
      password_rule: '密码至少包含一个大写字母，一个数字，一个特殊字符，并且长度在8-20之间',
      password_not_match: '两次密码不一致',
      user_unlocked_tip: '是否解锁账号'
    },
    userManage: {
      placeholder: '输入用户名进行模糊查询',
      btn_search: '查询',
      btn_reset: '重置',
      create: '新增用户',
      enable: '启用',
      disable: '禁用',
      edit: '编辑',
      reset_pwd: '恢复默认密码',
      delete: '删除',
      col_status: '账户状态',
      col_ip: '常用IP',
      user_type:'用户类型',
      user_admin: '管理员',
      user_user: '用户',
      delete_title: '删除确认',
      delete_tip: '您确认删除指定用户吗',
      change_status_title: '切换确认',
      change_status_tip: '您确认要切换开关状态吗?',
      create_title: '新建用户',
      create_org: '所属机构',
      create_username: '用户名',
      create_password: '初始密码',
      create_role: '角色',
      create_cancel: '取消',
      create_confirm: '确定',
      create_validate_password: '请输入密码',
      create_validate_org: '请选择所属机构',
      create_validate_role: '请选择角色',
      edit_title: '编辑用户',
      reset_password_tip:'此操作会将该账号重置为输入的密码，是否继续？',
      reset_password: '重置密码',
    },
    paramManagement: {
      add:'新增OTA参数',
      codeType:'参数类型',
      codeValue:'参数值',
      createUser:'创建人',
      createDate:'创建时间',
      operation:'操作',
      codeType_msg:'参数类型不能为空',
      codeValue_msg:'参数值不能为空',
      create_cancel:'取消',
      DEVTYPE:'设备类型',
      STANDARD:'定制类型',
      MODEL:'硬件配置',
      create_confirm:'确定',
      delete:'删除',
      delete_title:'删除确认',
      delete_tip:'您将删除选择的OTA参数，是否继续?',
      codeType_placeholder:'请选择参数类型'
    },
  },
  //报表
  report: {
    report: '报表',
    device_location_change:'设备位置变化',
    device_conn_analysis:'设备连接分析',
    network_conn_analysis:'网络连接分析',
    alive_device_analysis:"设备活跃情况",
    deviceApp_installStatistics:'应用安装情况',
    deviceEMVLog:"日志",
    bulk_task:"批量任务",
    export_task:"导出任务",
    dvcLocate: {
      search_txt: '筛选',
      search_org: '组织机构',
      search_time: '选择时间',
      search_location: '位置',
      search_close: '收起',
      search_export: '导出',
      search_search: '查询',
      search_reset: '重置',
      header: '设备位置变化',
      header_desc: '根据设备的位置变化，位置发生变化及时预警，有效的判断设备的合规性',
      column_history_location: '查看历史轨迹',
      column_org: '产权机构',
      column_time: '记录时间',
      column_tracking: '设备轨迹',
      modal_cancel: '取消',
      modal_ok: '确定',
    },
    dvcConnInfo:{
      title:'设备连接异常分析',
      content:'针对设备在工作环境下，根据PING包情况对设备wifi 信号质量进行数据统计分析，有效的判断作业环境下网络状态和设备状态。请注意，频繁采集会影响工作使用，建议采集频率＞1h。',
      query:{
        snOrTid:'SN/TID:',
        networkDelayAvg: '平均时延:',
        exceptionTimes: '异常次数:',
        location:'位置:',
        orgName:'组织机构:',
        time:'选择时间:',
      },
      orgName: '产权机构',
      ssid: 'SSID',
      networkDelayAvg: '平均时延(ms)',
      networkDelayMax: '最大时延(ms)',
      packetLossTimes: '丢包次数',
      exceptionTimes: '异常次数',
    },
    netConnection: {
      file_name: '网络连接分析',
      search_channel: '频道',
      header: '网络连接分析',
      desc: '基于设备网络情况对整个环境下网络AP进行数据分析，统计每个 ap ，信号状态和设备连接ap次数统计',
      col_channel: 'AP频道',
      col_avg: '平均网络强度（dBm）',
      col_lowest: '最低网络强度（dBm）',
      col_highest: '最高网络强度（dBm）',
    },
    aliveDevice:{
      data_x_line:"横坐标间隔:",
      alive_device_situation:"活跃情况",
      alive_device_mouth_num:"本月设备活跃度",
      alive_device_week_num:"本周设备活跃度",
      alive_device_num:"活跃设备数",
      hour:"小时",
      day:"天",
      time_over_tips: "按小时查询，选择的日期间隔不能超过7天",
    },
    deviceAppInstallStatistics: {
      file_name: "应用安装情况",
      sn: "SN",
      org_to_sn: "所属机构/商户",
      app_name: "应用名称",
      app_version_name: "版本名",
      export:'导出',
      btn_search: '查询',
      inputSn:'请输入设备编号',
      inputAppName:'请输入应用名称',
      inputAppVersionName:'请输入应用版本名称',
      require_one_of_three: '请至少填写 SN、应用名称、版本名称中的一项后再查询或导出',
    },
    bulkTask: {
      col_type: "任务类型",
      col_time_create: "任务创建时间",
      col_ignore_err: "忽略错误",
      col_status: "状态",
      col_status_pending: '执行中',
      col_status_complete: '导入成功',
      col_status_part_complete: '部分导入成功',
      col_status_fail: '导入失败',
      col_status_error: '处理异常',
      col_time_complete: '完成时间',
      import_success: '导入/成功',
      operator: '操作人',
      col_download_report: '下载错误报告',
      col_option: '操作',
      val_yes: '是',
      val_no: '否',
      type_org_add: '机构管理_批量入库',
      type_sn_apn_push: 'APN配置_SN推送',
      type_sn_wifi_push: 'WIFI配置_SN推送',
      type_sn_function_push: '功能设置_SN推送',
      type_sn_appDeploy_push: '应用部署_SN推送',
      type_sn_param_push: '参数配置_SN推送',
      type_sn_file_push: '文件分发_SN推送',
      type_sn_messagePush_push: '消息推送_SN推送',
      type_sn_deviceFence_push: '地理围栏_SN推送',
      type_sn_customDesk_push: '自定义桌面_SN推送',
      type_sn_occupyScreen_push: '霸屏应用_SN推送',
      type_sn_bootAnimation_push: '开机动画_SN推送',
      type_sn_silentApp_push: '默启应用_SN推送',
      type_sn_unInstall_push: '应用卸载_SN推送',
      type_sn_lockScreen_push: '锁屏密码_SN推送',
      type_sn_advertisement_push: '广告_SN推送',
      type_sn_strategy_push: '配置管理_SN推送',
      type_tid_apn_push: 'APN配置_TID推送',
      type_tid_wifi_push: 'WIFI配置_TID推送',
      type_tid_function_push: '功能设置_TID推送',
      type_tid_appDeploy_push: '应用部署_TID推送',
      type_tid_param_push: '参数配置_TID推送',
      type_tid_file_push: '文件分发_TID推送',
      type_tid_messagePush_push: '消息推送_TID推送',
      type_tid_deviceFence_push: '地理围栏_TID推送',
      type_tid_customDesk_push: '自定义桌面_TID推送',
      type_tid_occupyScreen_push: '霸屏应用_TID推送',
      type_tid_bootAnimation_push: '开机动画_TID推送',
      type_tid_silentApp_push: '默启应用_TID推送',
      type_tid_unInstall_push: '应用卸载_TID推送',
      type_tid_lockScreen_push: '锁屏密码_TID推送',
      type_tid_advertisement_push: '广告_TID推送',
      type_tid_strategy_push: '配置管理_TID推送',
      type_bulk_activation: '机构设备仓库_批量入库',
      type_bulk_move: '机构设备仓库_批量移库',
      type_bulk_bind: '机构设备仓库_批量绑定',
      type_bulk_delete: '机构设备仓库_批量删除',
      type_bulk_unbind: '机构设备仓库_批量解绑',
      btn_search: '查询',
    },
    exportTask: {
      task_tip: '导出操作可能耗费一点时间，结果将显示在{parMenu} >> {childMenu}',
      col_type: "任务类型",
      col_time_create: "任务创建时间",
      col_status: "状态",
      col_status_complete: '执行成功',
      col_status_fail: '执行失败',
      col_time_complete: '完成时间',
      operator: '操作人',
      col_download_report: '下载导出报告',
      no_report: '暂无数据',
      col_option: '操作',
      val_yes: '是',
      val_no: '否',
      btn_search: '查询',
      type_abnormal_devices_need_charge: '异常设备_需要充电',
      type_abnormal_devices_disabled: '异常设备_禁用',
      type_abnormal_devices_offline: '异常设备_离线',
      type_abnormal_devices_offline_two_days: '异常设备_离线超过48小时',
      type_abnormal_devices_unreport_two_days: '异常设备_超出48小时未上传信息',
      type_app_param_unhandled: '参数配置_未完成设备',
      type_app_param_success: '参数配置_已完成设备',
      type_app_param_failure: '参数配置_执行失败设备',
      type_app_deploy_unhandled: '应用部署_未完成设备',
      type_app_deploy_success: '应用部署_已完成设备',
      type_app_deploy_failure: '应用部署_执行失败设备',
      type_app_whitelist_unhandled: '应用白名单_未完成设备',
      type_app_whitelist_success: '应用白名单_已完成设备',
      type_app_whitelist_failure: '应用白名单_执行失败设备',
      type_app_survivalList_unhandled: '应用保活名单_未完成设备',
      type_app_survivalList_success: '应用保活名单_已完成设备',
      type_app_survivalList_failure: '应用保活名单_执行失败设备',
      type_terminal_detail: '设备详情',
      type_wifi_unhandled: 'WIFI配置_未完成设备',
      type_wifi_success: 'WIFI配置_已完成设备',
      type_wifi_failure: 'WIFI配置_执行失败设备',
      type_apn_unhandled: 'APN配置_未完成设备',
      type_apn_success: 'APN配置_已完成设备',
      type_apn_failure: 'APN配置_执行失败设备',
      type_file_distribution_unhandled: '文件分发_未完成设备',
      type_file_distribution_success: '文件分发_已完成设备',
      type_file_distribution_failure: '文件分发_执行失败设备',
      type_function_setting_unhandled: '功能设置_未完成设备',
      type_function_setting_success: '功能设置_已完成设备',
      type_function_setting_failure: '功能设置_执行失败设备',
      type_wifi_whitelist_unhandled: 'WIFI白名单_未完成设备',
      type_wifi_whitelist_success: 'WIFI白名单_已完成设备',
      type_wifi_whitelist_failure: 'WIFI白名单_执行失败设备',
      type_device_fence_unhandled: '地理围栏_未完成设备',
      type_device_fence_success: '地理围栏_已完成设备',
      type_device_fence_failure: '地理围栏_执行失败设备',
      type_message_push_unhandled: '消息推送_未完成设备',
      type_message_push_success: '消息推送_已完成设备',
      type_message_push_failure: '消息推送_执行失败设备',
      type_uninstall_app_unhandled: '应用卸载_未完成设备',
      type_uninstall_app_success: '应用卸载_已完成设备',
      type_uninstall_app_failure: '应用卸载_执行失败设备',
      type_lock_screen_password_unhandled: '锁屏密码下发_未完成设备',
      type_lock_screen_password_success: '锁屏密码下发_已完成设备',
      type_lock_screen_password_failure: '锁屏密码下发_执行失败设备',
      type_advertisement_unhandled: '广告_未完成设备',
      type_advertisement_success: '广告_已完成设备',
      type_advertisement_failure: '广告_执行失败设备',
      type_device_lifecycle: '设备生命周期',
      type_silent_app_unhandled: '默启应用_未完成设备',
      type_silent_app_success: '默启应用_已完成设备',
      type_silent_app_failure: '默启应用_执行失败设备',
      type_custom_desk_unhandled: '自定义桌面_未完成设备',
      type_custom_desk_success: '自定义桌面_已完成设备',
      type_custom_desk_failure: '自定义桌面_执行失败设备',
      type_occupy_screen_unhandled: '霸屏应用_未完成设备',
      type_occupy_screen_success: '霸屏应用_已完成设备',
      type_occupy_screen_failure: '霸屏应用_执行失败设备',
      type_boot_animation_unhandled: '开机动画_未完成设备',
      type_boot_animation_success: '开机动画_已完成设备',
      type_boot_animation_failure: '开机动画_执行失败设备',
      type_policy_management_unhandled: '配置管理_未完成设备',
      type_policy_management_success: '配置管理_已完成设备',
      type_policy_management_failure: '配置管理_执行失败设备',
      type_company_flow: '流量使用情况',
      type_device_app_flow: '应用排行',
      type_device_org_flow: '机构商户流量排行',
      type_device_org_flow_detail: '机构商户流量排行机构详情',
      type_device_location: '设备位置变化',
      type_device_conn_info: '设备连接分析',
      type_device_net_conn_analysis: '网络连接分析',
      type_device_alive_info: '设备活跃情况',
      type_device_app_install_statistics:'应用安装情况',
      type_device_ota_log: 'OTA升级日志',
    },
  },
}
export default message
